function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "m281.026,108.835c0-3.866-3.134-7-7-7h-231.7v-28.646h22v13.07c0,3.866 3.134,7 7,7s7-3.134 7-7v-20.07c0-3.866-3.134-7-7-7h-36c-3.866,0-7,3.134-7,7v35.646h-21.326c-3.866,0-7,3.134-7,7 0,43.948 26.415,81.837 64.199,98.64l-2.155,.901c-3.567,1.491-5.25,5.591-3.759,9.158 1.123,2.685 3.723,4.302 6.461,4.302 0.9,0 1.815-0.175 2.697-0.543l17.05-7.128c7.538,1.674 15.367,2.564 23.402,2.564h65.237c9.52,0 18.753-1.245 27.552-3.571l19.459,8.135c0.882,0.369 1.797,0.543 2.697,0.543 2.738,0 5.339-1.618 6.461-4.302 1.491-3.567-0.192-7.667-3.759-9.158l-5.599-2.341c36.114-17.462 61.083-54.47 61.083-97.2zm-107.894,93.894h-65.237c-49.419,0-90.044-38.377-93.636-86.895h252.51c-3.593,48.519-44.218,86.895-93.637,86.895z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    viewBox: "0 0 281.026 281.026",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 281.026 281.026"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/bathtub.1ff39ae1.svg";
export { SvgComponent as ReactComponent };